import { FC, useState } from "react";
import Section from "components/kaleido/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/kaleido/long/parts/Headline";
import Content from "components/kaleido/parts/Content";
import styled from "styled-components";
import useObserver from "lib/hooks/kaleido/useObserver";

const InitiativeList: FC = () => {
  const [visibleSection, setVisibleSection] = useState<string | null>(null);
  const sectionVisibilityFlags = useObserver(setVisibleSection);
  const isVisible = visibleSection === "initiativelist" || sectionVisibilityFlags["initiativelist"];

  return (
    <StyledSection className={`section ${isVisible ? "visible" : "hidden"}`} id="initiativelist">
      <AnchorTarget id="initiativelist" />
      <Headline src={"/image/lp/kaleido/initiative_list/head.png"} alt="進行中の企画" />
      <Content>
        <BannerArea>
          <Banner src="/image/lp/kaleido/initiative_list/project_3.jpg" alt="進行中の企画のバナー" />
        </BannerArea>
      </Content>
    </StyledSection>
  );
};
export default InitiativeList;

const StyledSection = styled(Section)`
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
  &.hidden {
    opacity: 0;
  }

  @media screen and (max-width: 400px) {
    margin-bottom: 60px;
  }
  @media screen and (min-width: 401px) {
    margin-bottom: 70px;
  }
  @media screen and (min-width: 501px) {
    margin-bottom: 100px;
  }
  @media screen and (min-width: 691px) {
    margin-bottom: 155px;
  }
  @media screen and (min-width: 1281px) {
    margin-bottom: 180px;
  }
`;
const Banner = styled.img`
  width: 80%;
  
  @media screen and (min-width: 1281px) {
    width: 70%;
    margin-bottom: 4vw;
    padding-top: 20px;
  }
`;
const BannerArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;
